import Head from "next/head";
import Layout from "layout/Layout/index.js";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Image from "next/image";

function InformationSecurityPolicy() {
    const { t } = useTranslation(["common", "nav", "contracts"]);
    const router = useRouter();

    return (
        <Layout>
            <Head>
                <title>{t("common:informationSecurityPolicy")}</title>
                <meta name="description" content={t("common:informationSecurityPolicyMetaDescription")} />
                <meta property="og:title" content={t("common:informationSecurityPolicy")} key="title" />
                <meta property="og:description" content={t("common:informationSecurityPolicyMetaDescription")} key="description" />
            </Head>


            <div className="py-10 lg:py-20 bg-makdosSecondaryGray">
                <div className="container px-5 py-2.5 mx-auto mb-10 lg:mb-4 bg-makdosYellow rounded-[4px] flex flex-col lg:flex-row items-center justify-center lg:justify-start text-center">
                    <Image
                        src={"/informationSecurtiyPolicyHeader.svg"}
                        alt={t("common:informationSecurityPolicyImageAlt")}
                        title={t("common:informationSecurityPolicyImageTitle")}
                        width={125}
                        height={125}
                    />
                    <h1 className="text-xl text-titleColor lg:text-[22px] lg:leading-20">
                        {t("common:informationSecurityPolicyMetaDescription")}
                    </h1>
                </div>
                <div className="container px-6 py-10 mx-auto bg-white rounded-md">
                    <div className="flex justify-center">
                        <span className="relative mb-8 text-4xl font-semibold text-after-shadow lg:text-5xl">{t("common:informationSecurityPolicy")}</span>
                    </div>



                    <div className={router.locale === "tr" ? "block" : "hidden"}>
                        <div className="col-md-12 terms">
                            <p>
                                Kuruluşumuz faaliyetleri esnasında hizmet vermekte olduğu müşterilerinin özel erişim/bağlantı bilgilerine,kritik cihazlara ait özel konfigürasyon ve iletişim bilgilerine sahip değildir.
                            </p>
                            <p>
                                Talep edilmesi durumunda hizmet verilen kurum ve kuruluşların güvenini temin etmek ve verdiğimiz hizmetler için kullandığımız bilgi varlıklarımızın güvenliğini sağlamamız öncelikli amacımızdır.
                            </p>
                            <p>
                                Bu bağlamda; iş birliğinde bulunduğumuz müşteriler, resmi kurumlar ve bayilerimiz ile ilişkilerimiz çok değerlidir.
                            </p>
                            <p>
                                Sunmakta olduğumuz hizmetlerin sürekliliği, elimizde tuttuğumuz bilgilerin gizliliği, müşterilerin veya kendi içimizdeki bilgi varlıklarının bütünlüğü yüksek öneme sahiptir.
                            </p>
                            <p>
                                Bu amaçla :
                            </p>
                            <ul>
                                <li>ISO 27001:2013 sistemini kurduk , etkinliğini sürekli iyileştirmeyi taahhüt ederiz.</li>
                                <li>Risklerimizi sürekli gözden geçiriyor ve kabul edilebilir seviyenin üstündeki riskler için kontroller uyguluyoruz.</li>
                                <li>Çalışanlarımızın bilgi güvenliği bilinçlerini yüksek tutarız.</li>
                                <li>TC yasa ve yönetmeliklerine tam olarak uymayı taahhüt ederiz.</li>
                                <li>Bu politikayı yılda bir kez gözden geçirerek güncel tutarız.</li>
                            </ul>
                            <p></p>
                            <br />
                            <br />
                            <div className="text-right"><b>Makdos Bilişim Teknolojileri</b></div>
                        </div>
                    </div>



                    <div className={router.locale === "tr" ? "hidden" : "block"}>
                        <div className="col-md-12">
                            <p>
                                Our organization does not possess access/connection information, critical device-specific configurations, or communication details during its operations.
                            </p>
                            <p>
                                If requested, our priority is to establish the trust of the institutions and organizations we serve and ensure the security of our information assets used for the services we provide.
                            </p>
                            <p>
                                In this context, our relationships with the customers, government agencies, and dealers we collaborate with are highly valuable.
                            </p>
                            <p>
                                The continuity of the services we provide, the confidentiality of the information we hold, and the integrity of the information assets of our customers or within our organization are of paramount importance.
                            </p>
                            <p>
                                For this purpose:
                            </p>
                            <ul>
                                <li>We have established the ISO 27001:2013 system and commit to continuously improve its effectiveness.</li>
                                <li>We continuously review our risks and implement controls for risks that exceed acceptable levels.</li>
                                <li>We ensure that our employees maintain a high level of awareness regarding information security.</li>
                                <li>We commit to fully comply with the laws and regulations of the Republic of Turkey.</li>
                                <li>We review and update this policy annually to keep it current.</li>
                            </ul>
                            <p></p>
                            <br /><br />
                            <div className="text-right"><b>Makdos Bilişim Teknolojileri</b></div>
                        </div>

                    </div>


                </div>
            </div>
        </Layout>
    );
}

export default InformationSecurityPolicy;

export const getServerSideProps = async ({ locale }) => {
    return {
        props: {
            ...await serverSideTranslations(locale, ["common", "nav", "contracts"])
        }
    };
};